import { contactDeleteApi } from "../../api/contact/contactDeleteApi"

type PayloadShape = Parameters<typeof contactDeleteApi>[0]

export async function contactDeleteService(payload: PayloadShape, token: string) {
	return await contactDeleteApi(payload, token)
}
